module.exports = __webpack_public_path__ + "static/media/tagging.18b3f566.svg";